import { TableColumnConfig } from './types';

// Default column configuration
export const defaultColumn: Partial<TableColumnConfig<any>> = {
  ellipsis: true,
  minWidth: 30,
  resizable: false,
};

// Height of header row in pixels
export const headerHeight = 40;

// Duration of long press when using touch-enabled devices
export const longPressDurationMs = 500;

// Thickness or row borders
export const rowBorderSize = 1;

// Height of each cell in pixels (excluding any borders)
export const rowCellHeight = 34;

// Width of the expander column
export const rowExpanderCellWidth = 32;

// Height of each row in pixels
export const rowHeight = rowCellHeight + rowBorderSize;

// Number of rows to render before and after the visible window
export const rowOverscanCount = 3;
